<template>
  <Menu as="div" class="inline-flex lg:relative">
    <button
      class="write-to-us-in-the-chat relative z-50 flex flex-col items-center justify-center pr-2 lg:h-[50px]"
    >
      <span class="relative md:mr-5">
        <span
          class="absolute -right-1 -top-1 z-10 inline-flex h-[14px] w-[14px] items-center justify-center rounded-full bg-light text-[10px] text-white xs:-top-1.5 xs:right-1 xs:h-[18px] xs:w-[18px]"
        >
          {{ unreadMessagesCount }}
        </span>
        <img
          src="@/assets/images/base/icons/mail.svg"
          class="transition-ease-in-out mr-1 inline-block h-[13px] w-[16px] hover:opacity-70 xs:mr-4 xs:h-[15px] xs:w-[18px]"
          alt="user-icon"
          aria-label="Account"
        />
      </span>
    </button>
    <MenuButton
      class="z-50 flex flex-col items-center justify-center lg:h-[50px]"
    >
      <div class="rounded-full bg-accent bg-opacity-5 p-[7px] xs:p-[8px]">
        <img
          src="@/assets/images/base/icons/user.svg"
          class="transition-ease-in-out block h-[15px] w-[15px] hover:opacity-70 xs:h-[17px] xs:w-[17px]"
          loading="lazy"
          alt="user-icon"
        />
      </div>
      <span
        class="transition-ease-in-out hidden flex-col text-[10px] font-bold text-[#4E389D] hover:text-primary-light lg:inline-flex"
        v-if="currentUser"
      >
        <span class="max-w-[83px] truncate">{{
          currentUser.first_name
        }}</span></span
      >
    </MenuButton>
    <RolesModal />

    <transition
      leave-active-class="transition ease-in duration-100"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <MenuItems
        v-if="currentUser"
        class="absolute -left-4 top-20 z-50 w-screen bg-[#E5E5E5] shadow-medium focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 lg:-left-16 lg:top-7 lg:mt-8 lg:h-auto lg:w-max lg:min-w-max lg:rounded-[20px]"
      >
        <MenuItem v-slot="{ close }">
          <router-link
            :to="{ name: 'Dashboard' }"
            class="transition-ease-in-out block w-full bg-white px-4 py-5 text-left text-sm font-medium leading-snug text-[#4E389D] hover:text-primary-light lg:rounded-t-[20px]"
            @click="close"
          >
            <span>
              {{ $t("account.dashboard") }}
            </span>
          </router-link>
        </MenuItem>

        <!--        <MenuItem v-slot="{ close }">-->
        <!--          <router-link-->
        <!--            :to="{ name: 'WeightLossChat' }"-->
        <!--            class="transition-ease-in-out block w-full bg-white px-4 py-5 text-left text-sm font-medium leading-snug text-[#4E389D] hover:text-primary-light"-->
        <!--            @click="close"-->
        <!--          >-->
        <!--            <span>-->
        <!--              {{ $t("account.weight_loss") }}-->
        <!--            </span>-->
        <!--          </router-link>-->
        <!--        </MenuItem>-->

        <MenuItem v-slot="{ close }">
          <router-link
            :to="{ name: 'Visits' }"
            class="transition-ease-in-out block w-full bg-white px-4 py-5 text-left text-sm font-medium leading-snug text-[#4E389D] hover:text-primary-light"
            @click="close"
          >
            <span>
              {{ $t("account.scheduled_visits") }}
            </span>
          </router-link>
        </MenuItem>

        <MenuItem v-slot="{ close }">
          <router-link
            :to="{ name: 'Doctors' }"
            class="transition-ease-in-out block w-full bg-white px-4 py-5 text-left text-sm font-medium leading-snug text-[#4E389D] hover:text-primary-light"
            @click="close"
          >
            <span>
              {{ $t("account.your_doctors") }}
            </span>
          </router-link>
        </MenuItem>

        <MenuItem v-slot="{ close }">
          <router-link
            :to="{ name: 'Settings' }"
            class="transition-ease-in-out block w-full bg-white px-4 py-5 text-left text-sm font-medium leading-snug text-[#4E389D] hover:text-primary-light"
            @click="close"
          >
            <span>
              {{ $t("account.profile_settings") }}
            </span>
          </router-link>
        </MenuItem>

        <MenuItem v-slot="{ close }">
          <router-link
            :to="{ name: 'Results' }"
            class="transition-ease-in-out block w-full bg-white px-4 py-5 text-left text-sm font-medium leading-snug text-[#4E389D] hover:text-primary-light"
            @click="close"
          >
            <span>
              {{ $t("layouts.results") }}
            </span>
          </router-link>
        </MenuItem>

        <MenuItem v-if="currentUser && currentUser.available_roles.length > 1">
          <ShowRoles class="z-50" />
        </MenuItem>

        <MenuItem>
          <button
            class="transition-ease-in-out block w-full bg-white px-4 py-5 text-left text-sm font-medium leading-snug text-[#4E389D] hover:text-primary-light lg:rounded-b-[20px]"
            @click="onClickLogout"
          >
            <span>{{ $t("auth.logout") }}</span>
          </button>
        </MenuItem>
      </MenuItems>

      <MenuItems
        v-else
        class="absolute -left-4 top-20 z-50 w-screen bg-[#E5E5E5] shadow-medium focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 lg:top-3 lg:mt-8 lg:h-auto lg:w-max lg:min-w-max lg:rounded-[20px]"
      >
        <MenuItem v-slot="{ close }">
          <router-link
            :to="{ name: 'LoginPatient' }"
            class="transition-ease-in-out block w-full bg-white px-4 py-5 text-left text-sm font-medium leading-snug text-[#4E389D] hover:text-primary-light lg:rounded-t-[20px]"
            @click="close"
          >
            <span>
              {{ $t("auth.sign_in") }}
            </span>
          </router-link>
        </MenuItem>

        <MenuItem v-slot="{ close }">
          <router-link
            :to="{
              name: 'RegisterPatient',
              query: { redirect: fullRedirectAfterRegisterPath },
            }"
            class="transition-ease-in-out block w-full bg-white px-4 py-5 text-left text-sm font-medium leading-snug text-[#4E389D] hover:text-primary-light lg:rounded-b-[20px]"
            @click="close"
          >
            {{ $t("auth.sign_up") }}
          </router-link>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import ShowRoles from "@/components/Core/ShowRoles.vue";
import RolesModal from "@/components/Modals/RolesModal.vue";

export default {
  name: "LayoutsUserDropdown",
  components: {
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    ShowRoles,
    RolesModal,
  },
  computed: {
    fullRedirectAfterRegisterPath() {
      if (this.$route.name === "RegisterPatient") {
        return undefined;
      }

      return `${window.location.origin}${this.$route.href}`;
    },
    ...mapGetters({
      currentUserRole: "user/getCurrentUserRole",
      currentUser: "user/getCurrentUser",
      unreadMessagesCount: "app/getUnreadMessagesCount",
    }),
  },
  methods: {
    async onClickLogout() {
      await this.logout();
      this.$router.push({ name: "LoginPatient" });
    },
    ...mapActions({ logout: "auth/logout" }),
  },
};
</script>
